export default __webpack_public_path__ + "static/media/thermometer-social.64d6f9b5.png";